import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setCameraImageIsRendering } from "../../../stateManagement/reducers/PanoramaSlice";

const no_image_icon = require('../../../assets/images/icons/no_image_icon.svg').default

// Компонент - окно для отображения миниатюры одной камеры
export function SmallFrameWidget({ url, amount, name }: any) {
    const dispatch = useDispatch();
    const [fetchTryNumber, setFetchTryNumber] = useState(1)
    const [imageSrc, setImageSrc] = useState<any>(no_image_icon)
    const [noImageFlag, setNoImageFlag] = useState(true)

    function cameraIsLoaded() {
        dispatch(setCameraImageIsRendering(false))
    }

    useEffect(() => {
        if (url) {
            fetchImage(url)
        }
    }, [url, fetchTryNumber])

    async function fetchImage(url: string) {
        try {
            const response = await fetch(url + `&fetchTryNumber=${fetchTryNumber}`, {
                method: 'GET',
            })
            let responseCopy = response.clone();
            const blobData = await response.blob()
            if (blobData?.type === 'image/jpeg') {
                const imageUrl = URL.createObjectURL(blobData);
                setImageSrc(imageUrl)
                setNoImageFlag(false)
            } else {
                if (fetchTryNumber === 2) {
                    setImageSrc(no_image_icon)
                    setNoImageFlag(true)
                    cameraIsLoaded()
                } else {
                    try {
                        const jsonData = await responseCopy.json()
                        if (jsonData?.Error) {
                            setImageSrc(no_image_icon)
                            setNoImageFlag(true)
                            cameraIsLoaded()
                        } else {
                            setFetchTryNumber((prev: any) => prev + 1)
                        }
                    } catch (jsonError: any) {
                        setImageSrc(no_image_icon)
                        setNoImageFlag(true)
                        cameraIsLoaded()
                    }
                }
            }
        } catch (error: any) {
            setImageSrc(no_image_icon)
            setNoImageFlag(true)
            cameraIsLoaded()
        }
    }

    return (
        <>
            <div className={`all-cams-${amount} cameras-grid-elem`}>
                <img className={noImageFlag ? "non-camera-picture" : "camera-image"}
                    src={imageSrc}
                    alt="RoadCamera"
                    draggable="false"
                    onLoad={cameraIsLoaded}
                    onError={cameraIsLoaded}
                />
                <div className="camera-name">
                    {name}
                </div>
            </div>
        </>
    );
}

